<script lang="ts">
  import { appStore } from "$app/store.svelte"

  interface Props {
    podcast_episode: PodcastEpisodeType
    show_link: boolean
  }

  let { podcast_episode, show_link = false }: Props = $props()
</script>

<article aria-labelledby="episode-4-title" class="py-10 sm:py-12">
  <div class="lg:px-8">
    <div class="lg:max-w-4xl">
      <div class="mx-auto px-4 sm:px-6 md:max-w-2xl md:px-4 lg:px-0">
        <div class="flex flex-col items-start">
          <h2
            id="episode-4-title"
            class="mt-2 text-xl font-bold text-slate-900"
          >
            {#if show_link}
              <a
                href="/plans/{appStore.plan.id}/podcast/{podcast_episode.id}"
                class="hover:underline hover:text-blue-500"
                >{podcast_episode.episode}: {podcast_episode.title}</a
              >
            {:else}
              {podcast_episode.episode}: {podcast_episode.title}
            {/if}
          </h2>
          <time
            datetime="2022-02-17T00:00:00.000Z"
            class="order-first font-mono text-sm leading-7 text-slate-500"
            >{podcast_episode.published_date}</time
          >
          <p class="mt-3 text-base leading-7 text-slate-700 prose prose-slate">
            {@html podcast_episode.summary}
          </p>
          <div class="mt-4 flex items-center gap-4">
            <span aria-hidden="true" class="text-sm font-bold text-slate-400"
            ></span>
            <audio controls src={podcast_episode.audio_url}>
              <a href={podcast_episode.audio_url}> Download audio </a>
            </audio>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
